<script setup lang="ts">
import MainLayout from 'views/layouts/MainLayout.vue'
import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'  
</script>
<template>
  <MainLayout #="{ showModalMessages }">
    <div class="slot-body">
      <div v-if="!isMobile()" class="box-gray"></div>
      <div class="container">
        <div class="row pt-5 align-items-center">
          <div class="col-lg-2 col-4">
            <h1 class="title mt-4">
              {{ translate.title }}
            </h1>
          </div>
          <div class="col-lg-5 col-1">
            <span class="subtitle">
              {{ translate.subTitle }}
            </span>
          </div>
          <div class="col-lg-4 col-7 offset-lg-1 d-flex align-items-center box-input">
            <input type="text" name="search" id="search-columns"
              :placeholder="!isMobile() ? translate.searchPlaceholder : ''" v-model="search"
              @keyup.enter="searchColumns(showModalMessages)" @keyup="clearSearchText"/>
            <font-awesome-icon :icon="['fas', 'search']" size="sm" @click="searchColumns(showModalMessages)"/>
          </div>
        </div>
        <div class="mt-4" v-if="!searchText">
          <ColunasHome :title-visible="false" :button-mobile="false" :button-more="false" @getArticleTagId="getArticleTagId"/>
        </div>
        <div class="mt-3">
          <div v-if="searchText">
            <div class="search-div" v-if="searchTextKeyUp"><br>{{ translate.searchTerm }} <strong>{{ search }}</strong><br><br></div>          
            <div v-if="searchTextKeyUp && !postColumns.length">{{ translate.searchNoRecords }}<br><br></div>
          </div>
          <ColumnsCardsMobile :posts="postColumns" v-if="isMobile()" />
          <ColumnsCards :posts="postColumns" v-else />
        </div>
        <div class="row d-flex align-items-center justify-content-center" v-if="postColumns.length >= limit">
          <button type="button" class="more-blog my-5 p-3 col-lg-3 col-8" @click="readMore">{{ translate.readMore }}
            <font-awesome-icon :icon="['fas', 'arrow-down']" size="md" /></button>
        </div>
        <div class="row mt-3 pb-5 d-flex align-items-center justify-content-center">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
          <!--
          <img
            class="img-banner-rodape"
            :src="translate.imgBannerRodape.src"
            :alt="translate.imgBannerRodape.name"
          />
          -->
        </div>
      </div>
    </div>
  </MainLayout>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { mapState } from 'pinia'
import { localeStore } from 'stores/locale'
import translaters from 'tradutors/columns'
import ColunasHome from '../../components/HomePage/ColunasHome.vue'
import ColumnsCards from '../../components/ColumnsCards/Cards.vue'
import ColumnsCardsMobile from '../../components/ColumnsCards/CardsMobile.vue'
import { isMobile } from 'views/shared/utils/mobile'
import api from '../../api'

export default defineComponent({
  name: 'ColumnsPage',
  emits: ['showModalMessages'],  
  components: {
    BannerAssineHorizontal
  },
  created() {
    const lang = ['pt-br', 'en']
    if (lang.indexOf(this.$route.params.locale) === -1) {
      window.location.replace('/')
    }
  },
  computed: {
    ...mapState(localeStore, ['locale']),
    translate: function (value) {
      if (this.locale === 'pt-br') {
        return translaters.portugues
      } else {
        return translaters.ingles
      }
    }
  },
  head() {
    return {
      templateParams: {
        subTitle: null, 
        subPage: this.translate.title,
        page_url: window.location.origin + this.$route.fullPath,
        page_description: this.locale == 'pt-br' ?
          `Fique atualizado sobre o melhor do universo masculino.` :
          `Stay updated on the best of the male universe.`,
        page_image: '/favicon.ico',
        page_keywords: 'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
        page_locale: this.locale,
        page_url_pt: "https://belladasemana.com.br/pt-br/colunas",
        page_url_en: "https://belladasemana.com.br/en/colunas",
        page_canonical: "https://belladasemana.com.br"+this.$route.fullPath,        
      }
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      postColumns: [],
      limit: 10,
      bannerAssineHorizontal: '',
      articleTagId: 9999,
      search: '',
      searchText: false,
      searchTextKeyUp: false
    }
  },
  watch: {
    locale: function () {
      this.getDados()    
      this.getBannerAssineHorizontal(true)
    },
    'search': function (value) {
      if (value == '') {
        this.searchText = false
        this.getDados()
      }
    },
  },
  mounted() {
    this.getBannerAssineHorizontal()
  },
  methods: {
    async getDados() {
      await api.get(`v1/colunas/getColumns?search=${this.search}&articletag=${this.articleTagId}&language=${this.locale ?? ''}&limit=${this.limit}&mobile=${this.isMobile}`).then(({ data }) => {
        this.postColumns = data.postsColumns
      })
      if (this.search != "") {
        this.searchTextKeyUp = true        
      }
    },
    async readMore() {
      this.limit += 3
      await this.getDados()
    },
    async getBannerAssineHorizontal(changeLanguage = false) {
      if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
      api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
        this.bannerAssineHorizontal = data.bannerAssineHorizontal
        sessionStorage.setItem(
            "bannerAssineHorizontal",
            JSON.stringify(this.bannerAssineHorizontal)
          );
      })
      else
        this.bannerAssineHorizontal = JSON.parse(
          sessionStorage.getItem("bannerAssineHorizontal")
        );
    },
    getArticleTagId(data) {
      this.articleTagId = data.articleTagId
      this.limit = 10
      this.search = ''      
      this.searchText = false      
      this.getDados()
    },
    searchColumns(message){
      if (this.search != '') {
        this.searchText = true
        this.searchTextKeyUp = true
        this.articleTagId = 9999
        this.limit = 10
        this.getDados()
      } else {
        this.searchText = false
        return message({
          message: {
            show: true,
            title: this.locale == 'pt-br' ? 'Aviso' : 'Notice',
            textButton: this.locale == 'pt-br' ? 'Fechar' : 'Close',
            textBoby: this.locale == 'pt-br' ? 'Informe algum termo para busca!' : 'Enter a search term'
          }
        })
      }
    },
    clearSearchText(){
      this.searchTextKeyUp = false
    }
  }
})
</script>

<style scoped lang="css">
.slot-body {
  margin-top: 65px !important;  
  background-color: #fff !important;
}

.box-gray {
  background-color: #f8f8f8;
  width: 100%;
  height: 333px;
  position: absolute;
}

.title {
  font-family: 'Bebas-Neue-Light';
  color: #000000;
  font-size: 64px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 77px;
}

#search-columns {
  padding: 0 !important;
  padding-left: 30px !important;
  font-size: 1rem !important;
  background-color: #f8f8f8 !important;
  border: 1px solid #ced4da !important;
  border-radius: 30px !important;
  height: 51px !important;
  width: 100%;
}

.box-input svg {
  position: absolute;
  right: 45px;
  z-index: 9;
  color: #b20;
  cursor: pointer;
}

.subtitle {
  height: 56px;
  color: #5b5858;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;
}

.more-blog {
  font-size: 1rem !important;
  font-weight: 500;
  background-color: black !important;
  border: 1px solid black !important;
  border-radius: 30px !important;
  color: white;
}

.more-blog svg {
  color: #b20;
  margin-left: 8px;
}

.search-div {
  top: -50px;
  position: absolute;
}

@media screen and (max-width: 769px) {
  .subtitle {
    display: none;
  }

  .title {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 48px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 58px;
  }

  #search-columns {
    height: 38px !important;
  }

  .box-input svg {
    right: 20px;
    z-index: 9;
  }

  .search-div {
    top: -55px;
  }  
}
</style>
